import { lazy } from 'react';

export const IconsMap = {
  ['AB']: lazy(() => import('./icons/ab.icon.svg?react')),
  ['AD']: lazy(() => import('./icons/ad.icon.svg?react')),
  ['AE']: lazy(() => import('./icons/ae.icon.svg?react')),
  ['AF']: lazy(() => import('./icons/af.icon.svg?react')),
  ['AG']: lazy(() => import('./icons/ag.icon.svg?react')),
  ['AI']: lazy(() => import('./icons/ai.icon.svg?react')),
  ['AL']: lazy(() => import('./icons/al.icon.svg?react')),
  ['AM']: lazy(() => import('./icons/am.icon.svg?react')),
  ['AO']: lazy(() => import('./icons/ao.icon.svg?react')),
  ['AQ']: lazy(() => import('./icons/aq.icon.svg?react')),
  ['AR']: lazy(() => import('./icons/ar.icon.svg?react')),
  ['AS']: lazy(() => import('./icons/as.icon.svg?react')),
  ['AT']: lazy(() => import('./icons/at.icon.svg?react')),
  ['AU']: lazy(() => import('./icons/au.icon.svg?react')),
  ['AW']: lazy(() => import('./icons/aw.icon.svg?react')),
  ['AX']: lazy(() => import('./icons/ax.icon.svg?react')),
  ['AZ']: lazy(() => import('./icons/az.icon.svg?react')),
  ['BA']: lazy(() => import('./icons/ba.icon.svg?react')),
  ['BB']: lazy(() => import('./icons/bb.icon.svg?react')),
  ['BD']: lazy(() => import('./icons/bd.icon.svg?react')),
  ['BE']: lazy(() => import('./icons/be.icon.svg?react')),
  ['BF']: lazy(() => import('./icons/bf.icon.svg?react')),
  ['BG']: lazy(() => import('./icons/bg.icon.svg?react')),
  ['BH']: lazy(() => import('./icons/bh.icon.svg?react')),
  ['BI']: lazy(() => import('./icons/bi.icon.svg?react')),
  ['BJ']: lazy(() => import('./icons/bj.icon.svg?react')),
  ['BL']: lazy(() => import('./icons/bl.icon.svg?react')),
  ['BM']: lazy(() => import('./icons/bm.icon.svg?react')),
  ['BN']: lazy(() => import('./icons/bn.icon.svg?react')),
  ['BO']: lazy(() => import('./icons/bo.icon.svg?react')),
  ['BQ']: lazy(() => import('./icons/bq.icon.svg?react')),
  ['BR']: lazy(() => import('./icons/br.icon.svg?react')),
  ['BS']: lazy(() => import('./icons/bs.icon.svg?react')),
  ['BT']: lazy(() => import('./icons/bt.icon.svg?react')),
  ['BV']: lazy(() => import('./icons/bv.icon.svg?react')),
  ['BW']: lazy(() => import('./icons/bw.icon.svg?react')),
  ['BY']: lazy(() => import('./icons/by.icon.svg?react')),
  ['BZ']: lazy(() => import('./icons/bz.icon.svg?react')),
  ['CA']: lazy(() => import('./icons/ca.icon.svg?react')),
  ['CC']: lazy(() => import('./icons/cc.icon.svg?react')),
  ['CD']: lazy(() => import('./icons/cd.icon.svg?react')),
  ['CF']: lazy(() => import('./icons/cf.icon.svg?react')),
  ['CH']: lazy(() => import('./icons/ch.icon.svg?react')),
  ['CI']: lazy(() => import('./icons/ci.icon.svg?react')),
  ['CK']: lazy(() => import('./icons/ck.icon.svg?react')),
  ['CL']: lazy(() => import('./icons/cl.icon.svg?react')),
  ['CM']: lazy(() => import('./icons/cm.icon.svg?react')),
  ['CN']: lazy(() => import('./icons/cn.icon.svg?react')),
  ['CO']: lazy(() => import('./icons/co.icon.svg?react')),
  ['CR']: lazy(() => import('./icons/cr.icon.svg?react')),
  ['CU']: lazy(() => import('./icons/cu.icon.svg?react')),
  ['CV']: lazy(() => import('./icons/cv.icon.svg?react')),
  ['CW']: lazy(() => import('./icons/cw.icon.svg?react')),
  ['CX']: lazy(() => import('./icons/cx.icon.svg?react')),
  ['CY']: lazy(() => import('./icons/cy.icon.svg?react')),
  ['CZ']: lazy(() => import('./icons/cz.icon.svg?react')),
  ['DE']: lazy(() => import('./icons/de.icon.svg?react')),
  ['DJ']: lazy(() => import('./icons/dj.icon.svg?react')),
  ['DK']: lazy(() => import('./icons/dk.icon.svg?react')),
  ['DM']: lazy(() => import('./icons/dm.icon.svg?react')),
  ['DO']: lazy(() => import('./icons/do.icon.svg?react')),
  ['DZ']: lazy(() => import('./icons/dz.icon.svg?react')),
  ['EC']: lazy(() => import('./icons/ec.icon.svg?react')),
  ['EE']: lazy(() => import('./icons/ee.icon.svg?react')),
  ['EG']: lazy(() => import('./icons/eg.icon.svg?react')),
  ['EH']: lazy(() => import('./icons/eh.icon.svg?react')),
  ['ER']: lazy(() => import('./icons/er.icon.svg?react')),
  ['EN']: lazy(() => import('./icons/en.icon.svg?react')),
  ['ES']: lazy(() => import('./icons/es.icon.svg?react')),
  ['ET']: lazy(() => import('./icons/et.icon.svg?react')),
  ['FI']: lazy(() => import('./icons/fi.icon.svg?react')),
  ['FJ']: lazy(() => import('./icons/fj.icon.svg?react')),
  ['FK']: lazy(() => import('./icons/fk.icon.svg?react')),
  ['FM']: lazy(() => import('./icons/fm.icon.svg?react')),
  ['FO']: lazy(() => import('./icons/fo.icon.svg?react')),
  ['FR']: lazy(() => import('./icons/fr.icon.svg?react')),
  ['GA']: lazy(() => import('./icons/ga.icon.svg?react')),
  ['GB']: lazy(() => import('./icons/gb.icon.svg?react')),
  ['GD']: lazy(() => import('./icons/gd.icon.svg?react')),
  ['GE']: lazy(() => import('./icons/ge.icon.svg?react')),
  ['GF']: lazy(() => import('./icons/gf.icon.svg?react')),
  ['GG']: lazy(() => import('./icons/gg.icon.svg?react')),
  ['GH']: lazy(() => import('./icons/gh.icon.svg?react')),
  ['GI']: lazy(() => import('./icons/gi.icon.svg?react')),
  ['GL']: lazy(() => import('./icons/gl.icon.svg?react')),
  ['GM']: lazy(() => import('./icons/gm.icon.svg?react')),
  ['GN']: lazy(() => import('./icons/gn.icon.svg?react')),
  ['GP']: lazy(() => import('./icons/gp.icon.svg?react')),
  ['GQ']: lazy(() => import('./icons/gq.icon.svg?react')),
  ['GR']: lazy(() => import('./icons/gr.icon.svg?react')),
  ['GS']: lazy(() => import('./icons/gs.icon.svg?react')),
  ['GT']: lazy(() => import('./icons/gt.icon.svg?react')),
  ['GU']: lazy(() => import('./icons/gu.icon.svg?react')),
  ['GY']: lazy(() => import('./icons/gy.icon.svg?react')),
  ['HK']: lazy(() => import('./icons/hk.icon.svg?react')),
  ['HM']: lazy(() => import('./icons/hm.icon.svg?react')),
  ['HN']: lazy(() => import('./icons/hn.icon.svg?react')),
  ['HR']: lazy(() => import('./icons/hr.icon.svg?react')),
  ['HT']: lazy(() => import('./icons/ht.icon.svg?react')),
  ['HU']: lazy(() => import('./icons/hu.icon.svg?react')),
  ['ID']: lazy(() => import('./icons/id.icon.svg?react')),
  ['IE']: lazy(() => import('./icons/ie.icon.svg?react')),
  ['IL']: lazy(() => import('./icons/il.icon.svg?react')),
  ['IM']: lazy(() => import('./icons/im.icon.svg?react')),
  ['IN']: lazy(() => import('./icons/in.icon.svg?react')),
  ['IO']: lazy(() => import('./icons/io.icon.svg?react')),
  ['IQ']: lazy(() => import('./icons/iq.icon.svg?react')),
  ['IR']: lazy(() => import('./icons/ir.icon.svg?react')),
  ['IS']: lazy(() => import('./icons/is.icon.svg?react')),
  ['IT']: lazy(() => import('./icons/it.icon.svg?react')),
  ['JE']: lazy(() => import('./icons/je.icon.svg?react')),
  ['JM']: lazy(() => import('./icons/jm.icon.svg?react')),
  ['JO']: lazy(() => import('./icons/jo.icon.svg?react')),
  ['JP']: lazy(() => import('./icons/jp.icon.svg?react')),
  ['KE']: lazy(() => import('./icons/ke.icon.svg?react')),
  ['KG']: lazy(() => import('./icons/kg.icon.svg?react')),
  ['KH']: lazy(() => import('./icons/kh.icon.svg?react')),
  ['KI']: lazy(() => import('./icons/ki.icon.svg?react')),
  ['KM']: lazy(() => import('./icons/km.icon.svg?react')),
  ['KN']: lazy(() => import('./icons/kn.icon.svg?react')),
  ['KP']: lazy(() => import('./icons/kp.icon.svg?react')),
  ['KR']: lazy(() => import('./icons/kr.icon.svg?react')),
  ['KW']: lazy(() => import('./icons/kw.icon.svg?react')),
  ['KY']: lazy(() => import('./icons/ky.icon.svg?react')),
  ['KZ']: lazy(() => import('./icons/kz.icon.svg?react')),
  ['LA']: lazy(() => import('./icons/la.icon.svg?react')),
  ['LB']: lazy(() => import('./icons/lb.icon.svg?react')),
  ['LC']: lazy(() => import('./icons/lc.icon.svg?react')),
  ['LI']: lazy(() => import('./icons/li.icon.svg?react')),
  ['LK']: lazy(() => import('./icons/lk.icon.svg?react')),
  ['LR']: lazy(() => import('./icons/lr.icon.svg?react')),
  ['LS']: lazy(() => import('./icons/ls.icon.svg?react')),
  ['LT']: lazy(() => import('./icons/lt.icon.svg?react')),
  ['LU']: lazy(() => import('./icons/lu.icon.svg?react')),
  ['LV']: lazy(() => import('./icons/lv.icon.svg?react')),
  ['LY']: lazy(() => import('./icons/ly.icon.svg?react')),
  ['MA']: lazy(() => import('./icons/ma.icon.svg?react')),
  ['MC']: lazy(() => import('./icons/mc.icon.svg?react')),
  ['MD']: lazy(() => import('./icons/md.icon.svg?react')),
  ['ME']: lazy(() => import('./icons/me.icon.svg?react')),
  ['MF']: lazy(() => import('./icons/mf.icon.svg?react')),
  ['MG']: lazy(() => import('./icons/mg.icon.svg?react')),
  ['MH']: lazy(() => import('./icons/mh.icon.svg?react')),
  ['MK']: lazy(() => import('./icons/mk.icon.svg?react')),
  ['ML']: lazy(() => import('./icons/ml.icon.svg?react')),
  ['MM']: lazy(() => import('./icons/mm.icon.svg?react')),
  ['MN']: lazy(() => import('./icons/mn.icon.svg?react')),
  ['MO']: lazy(() => import('./icons/mo.icon.svg?react')),
  ['MP']: lazy(() => import('./icons/mp.icon.svg?react')),
  ['MQ']: lazy(() => import('./icons/mq.icon.svg?react')),
  ['MR']: lazy(() => import('./icons/mr.icon.svg?react')),
  ['MS']: lazy(() => import('./icons/ms.icon.svg?react')),
  ['MT']: lazy(() => import('./icons/mt.icon.svg?react')),
  ['MU']: lazy(() => import('./icons/mu.icon.svg?react')),
  ['MV']: lazy(() => import('./icons/mv.icon.svg?react')),
  ['MW']: lazy(() => import('./icons/mw.icon.svg?react')),
  ['MX']: lazy(() => import('./icons/mx.icon.svg?react')),
  ['MY']: lazy(() => import('./icons/my.icon.svg?react')),
  ['MZ']: lazy(() => import('./icons/mz.icon.svg?react')),
  ['NA']: lazy(() => import('./icons/na.icon.svg?react')),
  ['NC']: lazy(() => import('./icons/fr.icon.svg?react')),
  ['NE']: lazy(() => import('./icons/ne.icon.svg?react')),
  ['NF']: lazy(() => import('./icons/nf.icon.svg?react')),
  ['NG']: lazy(() => import('./icons/ng.icon.svg?react')),
  ['NI']: lazy(() => import('./icons/ni.icon.svg?react')),
  ['NL']: lazy(() => import('./icons/nl.icon.svg?react')),
  ['NO']: lazy(() => import('./icons/no.icon.svg?react')),
  ['NP']: lazy(() => import('./icons/np.icon.svg?react')),
  ['NR']: lazy(() => import('./icons/nr.icon.svg?react')),
  ['NU']: lazy(() => import('./icons/nu.icon.svg?react')),
  ['NZ']: lazy(() => import('./icons/nz.icon.svg?react')),
  ['OM']: lazy(() => import('./icons/om.icon.svg?react')),
  ['PA']: lazy(() => import('./icons/pa.icon.svg?react')),
  ['PE']: lazy(() => import('./icons/pe.icon.svg?react')),
  ['PF']: lazy(() => import('./icons/pf.icon.svg?react')),
  ['PG']: lazy(() => import('./icons/pg.icon.svg?react')),
  ['PH']: lazy(() => import('./icons/ph.icon.svg?react')),
  ['PK']: lazy(() => import('./icons/pk.icon.svg?react')),
  ['PL']: lazy(() => import('./icons/pl.icon.svg?react')),
  ['PM']: lazy(() => import('./icons/pm.icon.svg?react')),
  ['PN']: lazy(() => import('./icons/pn.icon.svg?react')),
  ['PR']: lazy(() => import('./icons/pr.icon.svg?react')),
  ['PS']: lazy(() => import('./icons/ps.icon.svg?react')),
  ['PT']: lazy(() => import('./icons/pt.icon.svg?react')),
  ['PW']: lazy(() => import('./icons/pw.icon.svg?react')),
  ['PY']: lazy(() => import('./icons/py.icon.svg?react')),
  ['QA']: lazy(() => import('./icons/qa.icon.svg?react')),
  ['RE']: lazy(() => import('./icons/re.icon.svg?react')),
  ['RO']: lazy(() => import('./icons/ro.icon.svg?react')),
  ['RS']: lazy(() => import('./icons/rs.icon.svg?react')),
  ['RU']: lazy(() => import('./icons/ru.icon.svg?react')),
  ['RW']: lazy(() => import('./icons/rw.icon.svg?react')),
  ['SA']: lazy(() => import('./icons/sa.icon.svg?react')),
  ['SB']: lazy(() => import('./icons/sb.icon.svg?react')),
  ['SC']: lazy(() => import('./icons/sc.icon.svg?react')),
  ['SD']: lazy(() => import('./icons/sd.icon.svg?react')),
  ['SE']: lazy(() => import('./icons/se.icon.svg?react')),
  ['SG']: lazy(() => import('./icons/sg.icon.svg?react')),
  ['SH']: lazy(() => import('./icons/sh.icon.svg?react')),
  ['SI']: lazy(() => import('./icons/si.icon.svg?react')),
  ['SJ']: lazy(() => import('./icons/sj.icon.svg?react')),
  ['SK']: lazy(() => import('./icons/sk.icon.svg?react')),
  ['SL']: lazy(() => import('./icons/sl.icon.svg?react')),
  ['SM']: lazy(() => import('./icons/sm.icon.svg?react')),
  ['SN']: lazy(() => import('./icons/sn.icon.svg?react')),
  ['SO']: lazy(() => import('./icons/so.icon.svg?react')),
  ['SR']: lazy(() => import('./icons/sr.icon.svg?react')),
  ['SS']: lazy(() => import('./icons/ss.icon.svg?react')),
  ['ST']: lazy(() => import('./icons/st.icon.svg?react')),
  ['SV']: lazy(() => import('./icons/sv.icon.svg?react')),
  ['SY']: lazy(() => import('./icons/sy.icon.svg?react')),
  ['SZ']: lazy(() => import('./icons/sz.icon.svg?react')),
  ['TC']: lazy(() => import('./icons/tc.icon.svg?react')),
  ['TD']: lazy(() => import('./icons/td.icon.svg?react')),
  ['TF']: lazy(() => import('./icons/tf.icon.svg?react')),
  ['TG']: lazy(() => import('./icons/tg.icon.svg?react')),
  ['TH']: lazy(() => import('./icons/th.icon.svg?react')),
  ['TJ']: lazy(() => import('./icons/tj.icon.svg?react')),
  ['TK']: lazy(() => import('./icons/tk.icon.svg?react')),
  ['TL']: lazy(() => import('./icons/tl.icon.svg?react')),
  ['TM']: lazy(() => import('./icons/tm.icon.svg?react')),
  ['TN']: lazy(() => import('./icons/tn.icon.svg?react')),
  ['TO']: lazy(() => import('./icons/to.icon.svg?react')),
  ['TR']: lazy(() => import('./icons/tr.icon.svg?react')),
  ['TT']: lazy(() => import('./icons/tt.icon.svg?react')),
  ['TV']: lazy(() => import('./icons/tv.icon.svg?react')),
  ['TW']: lazy(() => import('./icons/tw.icon.svg?react')),
  ['TZ']: lazy(() => import('./icons/tz.icon.svg?react')),
  ['UA']: lazy(() => import('./icons/ua.icon.svg?react')),
  ['UG']: lazy(() => import('./icons/ug.icon.svg?react')),
  ['UN']: lazy(() => import('./icons/un.icon.svg?react')),
  ['US']: lazy(() => import('./icons/us.icon.svg?react')),
  ['UY']: lazy(() => import('./icons/uy.icon.svg?react')),
  ['UZ']: lazy(() => import('./icons/uz.icon.svg?react')),
  ['VA']: lazy(() => import('./icons/va.icon.svg?react')),
  ['VC']: lazy(() => import('./icons/vc.icon.svg?react')),
  ['VE']: lazy(() => import('./icons/ve.icon.svg?react')),
  ['VG']: lazy(() => import('./icons/vg.icon.svg?react')),
  ['VI']: lazy(() => import('./icons/vi.icon.svg?react')),
  ['VN']: lazy(() => import('./icons/vn.icon.svg?react')),
  ['VU']: lazy(() => import('./icons/vu.icon.svg?react')),
  ['WF']: lazy(() => import('./icons/wf.icon.svg?react')),
  ['WS']: lazy(() => import('./icons/ws.icon.svg?react')),
  ['XK']: lazy(() => import('./icons/xk.icon.svg?react')),
  ['YE']: lazy(() => import('./icons/ye.icon.svg?react')),
  ['YT']: lazy(() => import('./icons/yt.icon.svg?react')),
  ['ZA']: lazy(() => import('./icons/za.icon.svg?react')),
  ['ZM']: lazy(() => import('./icons/zm.icon.svg?react')),
  ['ZW']: lazy(() => import('./icons/zw.icon.svg?react')),
} as const;

export type CountryCodeType = keyof typeof IconsMap;
